export enum StepKind {
    START = 0,
    TASK = 1,
    END = 2
}